const BgRadial = ({id, color, width, height, top, bottom}: {
    id: string,
    color: string,
    width: string,
    height: string,
    top: string,
    bottom: string,
}) => {
    return (
        <div
            id={id}
            style={{
                width: width,
                height: height,
                background: `radial-gradient(ellipse, ${color} 15%, rgba(0, 0, 0, 0) 80%)`,
                filter: "blur(20px)",
                position: "absolute",
                top: top,
                bottom: bottom,
                left: "50%",
                transform: "translateX(-50%)",
                pointerEvents: "none",
                opacity: .3,
            }}
        />
    )
}

export default BgRadial;